export default "__VITE_ASSET__CVO7vJ4Q__"